<script>

export default {
    data: () => ({
        infos: {
            agenceIdf: null,
            francilienne: null,
            pme: null
        }
    }),
    props: {
        nbElements: {
            type: Number,
            required: true
        }
    },
    methods: {
        onReset(evt) {
            evt.preventDefault()
            this.infos = {
                agenceIdf: null,
                francilienne: null,
                pme: null
            }
        },
        onSubmit(ev) {
            ev.preventDefault()
            if (Object.values(this.infos).findIndex(el => el !== null) > -1) {
                this.$emit('submit', this.infos)
            }
        }
    }
}

</script>

<template>
    <b-card :header="`Modifier ${nbElements} élément${nbElements > 1 ? 's' : ''}`">
        <b-form @submit="onSubmit" @reset="onReset">
            <b-row>
                <b-col cols="6">
                    <b-form-group id="input-group-pme" label="PME (au titre de la recommandation 2003/361/CE)"
                        label-for="input-pme" label-class="typo-required-field">
                        <b-form-radio-group id="input-pme" v-model="infos.pme" :buttons="true"
                            button-variant="outline-primary">
                            <b-form-radio :value="true">Oui</b-form-radio>
                            <b-form-radio :value="false">Non</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group id="input-group-francilienne" label="Siège en IdF" label-for="input-francilienne"
                        label-class="typo-required-field">
                        <b-form-radio-group id="input-francilienne" v-model="infos.francilienne" :buttons="true"
                            button-variant="outline-primary">
                            <b-form-radio :value="true">Oui</b-form-radio>
                            <b-form-radio :value="false">Non</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group id="input-group-agenceIdf" label="Agence en IdF" label-for="input-agenceIdf"
                        label-class="typo-required-field">
                        <b-form-radio-group id="input-agenceIdf" v-model="infos.agenceIdf" :buttons="true"
                            button-variant="outline-primary">
                            <b-form-radio :value="true">Oui</b-form-radio>
                            <b-form-radio :value="false">Non</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-button type="submit" variant="primary">Modifier</b-button>
            <b-button type="reset" variant="danger">Réinitialiser</b-button>
        </b-form>
    </b-card>
</template>
